import { useLocation } from "react-router-dom";
import { Head } from "vite-react-ssg";

const BASE_URL = "https://www.hollinsandhur.com";
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image-logo.jpg`;
const SITE_NAME = "Hollins & Hur";

/**
 * Global SEO component injected via the root Layout.
 * Provides:
 *   – Single canonical tag per page (always https://www.hollinsandhur.com{path}, no query params)
 *   – noindex,nofollow on non-production domains (lovable.app, preview, etc.)
 *   – Default OG + Twitter tags (overridden by per-page <Head> when present)
 */
export const GlobalCanonical = () => {
  const { pathname } = useLocation();

  // Normalize: remove trailing slash (except root), strip query params
  const normalizedPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
  const canonicalUrl = `${BASE_URL}${normalizedPath}`;

  // Detect non-production domains
  const isNonProduction = typeof window !== "undefined" && !window.location.hostname.includes("hollinsandhur.com");

  console.log("Is non production", isNonProduction);

  return (
    <Head>
      {/* Canonical – always production domain, no query params */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Robots – noindex on non-production */}
      {isNonProduction && <meta name="robots" content="noindex, nofollow" />}

      {/* Default OpenGraph (per-page Head overrides these) */}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Default Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
    </Head>
  );
};
